module.exports = __webpack_public_path__ + "img/face_shape_male_heart.00c34486.png";